import React from 'react';
 
/**
 
 Create Training Parameter 
{ creator
  title:"",
  description:"",
  coverImage:"",
  autherName:"",
  visibility:"",
  trainingType:"",
  levels:"",
  categories:"",
  trainingTotalTime:"", 
  videoUrl:"",
  currentDate:""  
}
  authorName: "Amit"
category: "category"
coverImage: "5d89fd42e0cddf480a6ec5ee/coverImage.jpeg"
createdAt: "2019-09-24T11:25:54.299Z"
credits: "1000"
description: "vhgvhn"
imported: true
length: "180"
level: "allLevels"
name: "Security Awareness for Managers"
resource: "default.htm"
scormVersion: "2004 3rd Edition"
steps: "2"
type: "scorm"
videoUrl: ""
visibility: "0"
__v: 0
_id: "5d89fd42e0cddf480a6ec5ee"
 * 
 */
export const categoryList = [
  { label: "Select All", value: 0 },
  { label: "Premium", value: 1 },
  { label: "Standard", value: 2 },
  { label: "CSCU", value: 3 },
  { label: "Practice", value: 4 }
];

export const pricesList = ["All", "Free", "Paid"];

export const durationsList = [
  { label: "All", value: 0 },
  { label: "0-10 Minutes", value: 1 },
  { label: "10-15 Minutes", value: 2 },
  { label: "15-30 Minutes", value: 3 },
  { label: "30 + Minutes", value: 4 }
];

export const trainingData = [
  {
    title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/01.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11" , 
    organizationName:"OhPhish",
    categories:"",
    trainingTotalTime:""
  }, 
  {
    title:" React - The Complete Guide (incl Hooks, React Router, Redux",
    imageUrl:"/training/02.jpg",
    description:"Dive in and learn React 16.8 from scratch! Learn Reactjs, Hooks, Redux, React Routing, Animations, Next.js and way more!",
    rating:4.3,
    lectures:75,
    levels:"Development",
    updateDate:"2019-09-12" ,
    authorName:"Amit Chauhan",
    organizationName:"OhPhish",
    categories:"React",
    trainingTotalTime:"2 Hours"
  },
  {
    title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/03.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11" ,
    authorName:"Amit Chauhan",
    organizationName:"OhPhish",
    categories:"React",
    trainingTotalTime:"2 Hours"
  },
  {
    title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/01.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11", 
    authorName:"Amit Chauhan",
    organizationName:"OhPhish",
    categories:"React",
    trainingTotalTime:"2 Hours"
  },
  {
    title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/03.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11" ,
    // authorName:"",
    organizationName:"OhPhish",
    categories:"",
    trainingTotalTime:""
  }, 
  {
    title:" React - The Complete Guide (incl Hooks, React Router, Redux",
    imageUrl:"/training/02.jpg",
    description:"Dive in and learn React 16.8 from scratch! Learn Reactjs, Hooks, Redux, React Routing, Animations, Next.js and way more!",
    rating:4.3,
    lectures:75,
    levels:"Development",
    updateDate:"2019-09-12" ,
    authorName:"Amit Chauhan",
    organizationName:"OhPhish",
    categories:"React",
    trainingTotalTime:"2 Hours"
  },
  {
    title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/01.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11" ,
    authorName:"Amit Chauhan",
    organizationName:"OhPhish",
    categories:"React",
    trainingTotalTime:"2 Hours"
  },
  {
    title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/03.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11", 
    authorName:"Amit Chauhan",
    organizationName:"OhPhish",
    categories:"React",
    trainingTotalTime:"2 Hours"
  }
]

///src//training/01.jpg
export const campaignsAnalytics = {
  title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
  imageUrl:"/training/02.jpg",
  description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
  rating:4.5,
  lectures:75,
  levels:"All Levels",
  updateDate:"2019-09-11" 
};

export const trainingAnalytics = {
  title:"All LevelsThe Data Science Course 2019: Complete Data Science Bootcamp",
    imageUrl:"/training/01.jpg",
    description:"Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python, Machine & Deep ",
    rating:4.5,
    lectures:75,
    levels:"All Levels",
    updateDate:"2019-09-11" 
};

export const quizzerAnalytics = {
  title: 'Quizzer',
  completePercent : 50,
  total : 120,
  chartKey : 'quizzes',
  data: [
		{ name: 'Page A', quizzes: 400 },
		{ name: 'Page B', quizzes: 600 },
		{ name: 'Page C', quizzes: 800 },
		{ name: 'Page D', quizzes: 1200 },
		{ name: 'Page E', quizzes: 800 },
		{ name: 'Page F', quizzes: 600 },
		{ name: 'Page G', quizzes: 300 },
		{ name: 'Page H', quizzes: 900 },
		{ name: 'Page A', quizzes: 400 },
		{ name: 'Page B', quizzes: 600 },
		{ name: 'Page C', quizzes: 800 },
		{ name: 'Page D', quizzes: 1200 }
	]
};

export const taskList = [
	{
		id: 1,
		title: 'Make the home page dynamic',
		completed: false,
		user: {
			projectName: 'Chatbull',
			avatar: 'https://via.placeholder.com/150x150'
		},
		dueDate: 'Tomorrow',
		tags: [ 1, 2 ]
	},
	{
		id: 2,
		title: 'Design wireframes based on the requirements',
		completed: false,
		user: {
			projectName: 'Wieldy',
			avatar: 'https://via.placeholder.com/150x150'
		},
		dueDate: 'Today',
		tags: [ 2, 4 ]
	},
	{
		id: 3,
		title: 'Need to define microinteraction on click of signin button',
		completed: false,
		user: {
			projectName: 'Jumbo',
			avatar: 'https://via.placeholder.com/150x150'
		},
		dueDate: '21 Jul',
		tags: [ 1, 2, 3 ]
	},
	{
		id: 4,
		title: 'New page need to be designed for property listing',
		completed: false,
		user: {
			projectName: 'Wieldy',
			avatar: 'https://via.placeholder.com/150x150'
		},
		dueDate: '23 Jul',
		tags: [ 2, 3, 4 ]
	},
	{
		id: 5,
		title: 'Design wireframes based on the requirements',
		completed: false,
		user: {
			projectName: 'Wieldy',
			avatar: 'https://via.placeholder.com/150x150'
		},
		dueDate: '1 Aug',
		tags: [ 2, 4 ]
	}
];

export const recentActivity = [
	{
		id: 1,
		day: 'Today',
		tasks: [
			{
				id: 1,
				name: 'Mila Alba',
				title: [
					<span className="gx-link" key={1}>
						Mila Alba
					</span>,
					' left a 5 star review on ',
					<span className="gx-link" key={2}>
						Albama’s House
					</span>
				],
				avatar: 'https://via.placeholder.com/150x150',
				imageList: []
			},
			{
				id: 2,
				name: 'Bob Builder',
				title: [
					'Callback request from ',
					<span className="gx-link" key={3}>
						Bob Builder
					</span>,
					' for the property ',
					<span className="gx-link" key={4}>
						Dimitri House
					</span>
				],
				avatar: 'https://via.placeholder.com/150x150',
				imageList: []
			},
			{
				id: 3,
				name: 'Tom Moody',
				title: [
					'Congratulations to ',
					<span className="gx-link" key={5}>
						Tom Moody
					</span>,
					' for joining 10+ club '
				],
				avatar: 'https://via.placeholder.com/150x150',
				imageList: []
			},
			{
				id: 4,
				name: 'Norman Dolphi',
				title: [ 'Norman Dolphi is looking for a house in New Jersy, USA' ],
				avatar: '',
				imageList: []
			}
		]
	},
	{
		id: 2,
		day: 'Yesterday',
		tasks: [
			{
				id: 5,
				name: 'Kily Johns',
				title: [
					'Agent ',
					<span className="gx-link" key={7}>
						Kily Johns
					</span>,
					' has added 7 new photos to the property ',
					<span key={6} className="gx-link">
						Albama’s House
					</span>
				],
				avatar: '',
				imageList: [
					'https://via.placeholder.com/150x150',
					'https://via.placeholder.com/150x150',
					'https://via.placeholder.com/150x150',
					'https://via.placeholder.com/150x150',
					'https://via.placeholder.com/150x150',
					'https://via.placeholder.com/150x150',
					'https://via.placeholder.com/150x150'
				]
			},
			{
				id: 6,
				name: 'Tom Moody',
				title: [
					'Welcome to a new agent ',
					<span className="gx-link" key={8}>
						Tom Moody in the Company
					</span>
				],
				avatar: 'https://via.placeholder.com/150x150',
				imageList: []
			},
			{
				id: 7,
				name: 'Oliver Shorter',
				title: [
					<span className="gx-link" key={9}>
						Oliver Shorter
					</span>,
					' is looking for an office space in ',
					<span className="gx-link" key={10}>
						Colorado, USA
					</span>
				],
				avatar: 'https://via.placeholder.com/150x150',
				imageList: []
			},
			{
				id: 8,
				name: 'Mila Alba',
				title: [
					<span className="gx-link" key={11}>
						Mila Alba
					</span>,
					' left a 5 star review on ',
					<span className="gx-link" key={12}>
						Albama’s House
					</span>
				],
				avatar: 'https://via.placeholder.com/150x150',
				imageList: []
			}
		]
	}
];

export const ticketList = [
	{
		id: 1,
		avatar: 'https://via.placeholder.com/150x150',
		title: 'Need a quick support on setting',
		description: [
			<span className="gx-link" key={13}>
				Joy Parish
			</span>,
			'  created ticket 15 mins ago'
		],
		status: 2
	},
	{
		id: 2,
		avatar: 'https://via.placeholder.com/150x150',
		title: 'Pre-sale query about the product',
		description: [
			<span key={14} className="gx-link">
				You
			</span>,
			' replied 2 days ago'
		],
		status: 1
	},
	{
		id: 3,
		avatar: 'https://via.placeholder.com/150x150',
		title: 'Regarding customization service',
		description: [
			<span key={15} className="gx-link">
				Joy Parish
			</span>,
			' replied 2 days ago'
		],
		status: 4
	}
];
export const taskStatus = [
	{
		id: 1,
		title: 'Critical',
		color: 'red'
	},
	{
		id: 2,
		title: 'High',
		color: 'orange'
	},
	{
		id: 3,
		title: 'Medium',
		color: 'green'
	},
	{
		id: 4,
		title: 'Low',
		color: 'light-grey'
	}
];
export const taskTags = [
	{
		id: 1,
		name: 'HTML',
		color: 'red'
	},
	{
		id: 2,
		name: 'React',
		color: 'green'
	},
	{
		id: 3,
		name: 'JavaScript',
		color: 'blue'
	},
	{
		id: 4,
		name: 'CSS',
		color: 'orange'
	}
];
export const siteVisit = [
	{ name: '1', thisYear: 0, lastYear: 0 },
	{ name: '2', thisYear: 0, lastYear: 1 },
	{ name: '3', thisYear: 5, lastYear: 2 },
	{ name: '4', thisYear: 10, lastYear: 0 },
	{ name: '5', thisYear: 4, lastYear: 1 },
	{ name: '6', thisYear: 16, lastYear: 3 },
	{ name: '7', thisYear: 5, lastYear: 1 },
	{ name: '8', thisYear: 11, lastYear: 5 },
	{ name: '9', thisYear: 6, lastYear: 2 },
	{ name: '10', thisYear: 11, lastYear: 3 },
	{ name: '11', thisYear: 30, lastYear: 2 },
	{ name: '12', thisYear: 10, lastYear: 1 },
	{ name: '13', thisYear: 13, lastYear: 0 },
	{ name: '14', thisYear: 4, lastYear: 2 },
	{ name: '15', thisYear: 3, lastYear: 8 },
	{ name: '16', thisYear: 1, lastYear: 0 },
	{ name: '17', thisYear: 0, lastYear: 0 }
];

export const totalSaleData = [
	{ name: 'JAN', price: 600 },
	{ name: 'FEB', price: 3398 },
	{ name: 'MAR', price: 1200 },
	{ name: 'APR', price: 4908 },
	{ name: 'MAY', price: 2908 }
];

export const totalRevenueData = [
	{ name: 'JAN', thisYear: 60 },
	{ name: 'FEB', thisYear: 90 },
	{ name: 'MAR', thisYear: 50 },
	{ name: 'APR', thisYear: 75 },
	{ name: 'MAY', thisYear: 60 },
	{ name: 'JUN', thisYear: 85 },
	{ name: 'JUL', thisYear: 20 },
	{ name: 'AUG', thisYear: 75 },
	{ name: 'SEP', thisYear: 60 },
	{ name: 'OCT', thisYear: 40 },
	{ name: 'NOV', thisYear: 75 },
	{ name: 'DEC', thisYear: 25 }
];

export const trafficData = [
	{ name: 'Page A', value: 0 },
	{ name: 'Page B', value: 2000 },
	{ name: 'Page C', value: 600 },
	{ name: 'Page D', value: 4400 },
	{ name: 'Page D', value: 900 },
	{ name: 'Page H', value: 4860 }
];

export const campaignType = [
  {
    id : 1,
    type : 'email',
    title : 'Email',
    icon : 'mail'
  },
  {
    id : 2,
    type : 'sms',
    title : 'Sms',
    icon : 'message'
  },
  {
    id : 3,
    type : 'voice',
    title : 'Voice',
    icon : "phone"
  }
]

export const trainingData2 = [
    {
      "_id": "5d4276ce549e5f7175bf2c7d",
      "campaignId": {
        "_id": "5d4276ce549e5f7175bf2c7c",
        "userId": null,
        "organisationId": "5967086f7f005e0e0a4bd116",
        "trainingId": {
          "_id": "5d36a44e951e5446e527211b",
          "name": "Security Awareness - Strongest Link",
          "resource": "default.htm",
          "imported": true,
          "scormVersion": "2004 3rd Edition",
          "createdAt": "2019-07-23T06:08:14.234Z",
          "__v": 0
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "timeZone": "Asia/Kolkata",
        "demo": false,
        "name": "Test Training Campaign",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "groupedSelection": null,
        "createdAt": "2019-08-01T05:21:18.741Z",
        "triggeredAt": "2019-08-01T05:21:18.741Z",
        "expireAt": "2019-08-01T05:35:42.742Z",
        "requestedAt": "2019-08-01T05:21:18.742Z",
        "approvedAt": "2019-08-01T05:21:18.742Z",
        "rejectedAt": "2019-08-01T05:21:18.742Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay",
      "designation": "",
      "department": "",
      "branch": "",
      "group": "",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "Waiting for response from mail client",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "",
      "scoreMin": 0,
      "scoreMax": 0,
      "mode": "",
      "successStatus": "",
      "scoreScaled": "",
      "scoreRaw": 0,
      "completionStatus": "",
      "attempted": false,
      "submitted": false,
      "submissions": [],
      "started": false,
      "startedAt": null,
      "assignedAt": "2019-08-01T05:21:18.749Z",
      "submittedAt": null,
      "__v": 0
    },
    {
      "_id": "5d2ebc2a89f54a6be2843faa",
      "campaignId": {
        "_id": "5d2ebc2a89f54a6be2843fa9",
        "userId": "5bc055fae3a9aa409ce52d59",
        "organisationId": "5967086f7f005e0e0a4bd116",
        "trainingId": {
          "_id": "5cc929e4ae71e5553611b7ea",
          "name": "Information Security Training",
          "resource": "dist/index.html",
          "imported": false,
          "scormVersion": "2004",
          "content": {
            "present": {
              "version": "1",
              "lastActionDispatched": "CHANGE_GLOBAL_CONFIG",
              "globalConfig": {
                "title": "Information Security Training",
                "author": "",
                "canvasRatio": 1.7777777777777777,
                "age": {
                  "min": 0,
                  "max": 0
                },
                "typicalLearningTime": {
                  "h": 0,
                  "m": 0,
                  "s": 0
                },
                "rights": 1,
                "description": "",
                "thumbnail": "data:image/png;base64,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",
                "keywords": [],
                "version": "0.0.0",
                "status": "draft",
                "hideGlobalScore": false,
                "minTimeProgress": 30,
                "visorNav": {
                  "player": true,
                  "sidebar": true,
                  "keyBindings": true
                },
                "modifiedState": true,
                "showAlert": false,
                "everPublished": false
              },
              "boxesById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "parent": "pa-1497983247795",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%",
                    "type": "absolute"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "parent": "pa-1556687783945",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.9311200000000002%",
                    "y": "19.2446%",
                    "type": "absolute"
                  },
                  "content": {
                    "type": "div",
                    "key": null,
                    "ref": null,
                    "props": {
                      "className": "exercisePlugin truefalsePlugin",
                      "children": [
                        {
                          "type": "div",
                          "key": "-1",
                          "ref": null,
                          "props": {
                            "className": "row",
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12",
                                "children": {
                                  "key": "1",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Question",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>This is a True or False question. You can write here the general question statement here</p>",
                                    "pluginContainer": "Question"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        {
                          "type": "div",
                          "key": "0",
                          "ref": null,
                          "props": {
                            "className": "row TFRow",
                            "children": [
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons true",
                                      "children": "done"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons false",
                                      "children": "clear"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-10"
                                },
                                "_owner": null,
                                "_store": {}
                              }
                            ]
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        [
                          {
                            "type": "div",
                            "key": "1",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "1",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 1",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 1</p>",
                                        "pluginContainer": "Answer0"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "2",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "2",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 2",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 2</p>",
                                        "pluginContainer": "Answer1"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "3",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "3",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 3",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 3</p>",
                                        "pluginContainer": "Answer2"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          }
                        ],
                        {
                          "type": "div",
                          "key": "-2",
                          "ref": null,
                          "props": {
                            "className": "row feedbackRow",
                            "style": {
                              "display": "block"
                            },
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12 feedback",
                                "children": {
                                  "key": "-2",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Feedback",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>Here you can provide some feedback about the answer</p>",
                                    "pluginContainer": "Feedback"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        }
                      ]
                    },
                    "_owner": null,
                    "_store": {}
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [
                    "sc-Question",
                    "sc-Answer0",
                    "sc-Answer1",
                    "sc-Feedback"
                  ],
                  "sortableContainers": {
                    "sc-Question": {
                      "children": [
                        "bo-15566877928800"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Question",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer0": {
                      "children": [
                        "bo-15566877928801"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer0",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer1": {
                      "children": [
                        "bo-15566877928802"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer1",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Feedback": {
                      "children": [
                        "bo-15566877928804"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Feedback",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    }
                  },
                  "containedViews": []
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "parent": "bo-1556687792872",
                  "container": "sc-Question",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer0",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3ETrue%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer1",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EFalse%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "parent": "bo-1556687792872",
                  "container": "sc-Feedback",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                }
              },
              "boxSelected": -1,
              "boxLevelSelected": 0,
              "indexSelected": 0,
              "marksById": {},
              "navItemsIds": [
                "pa-1497983247795",
                "se-1556687774306",
                "pa-1556687783945"
              ],
              "navItemSelected": "pa-1556687783945",
              "navItemsById": {
                "0": {
                  "id": 0,
                  "children": [
                    "pa-1497983247795",
                    "se-1556687774306"
                  ],
                  "boxes": [],
                  "level": 0,
                  "type": "",
                  "hidden": false,
                  "isExpanded": true
                },
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "isExpanded": true,
                  "parent": 0,
                  "linkedBoxes": {},
                  "children": [],
                  "boxes": [
                    "bo-1556687732811"
                  ],
                  "level": 1,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "isExpanded": true,
                  "parent": 0,
                  "children": [
                    "pa-1556687783945"
                  ],
                  "boxes": [],
                  "linkedBoxes": {},
                  "level": 1,
                  "type": "section",
                  "hidden": false,
                  "extraFiles": {}
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "isExpanded": true,
                  "parent": "se-1556687774306",
                  "children": [],
                  "boxes": [
                    "bo-1556687792872"
                  ],
                  "linkedBoxes": {},
                  "level": 2,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                }
              },
              "containedViewsById": {},
              "containedViewSelected": 0,
              "displayMode": "list",
              "pluginToolbarsById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": 54.867775831873914,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "pluginId": "TrueFalse",
                  "state": {
                    "nBoxes": 2,
                    "showFeedback": false,
                    "allowPartialScore": true,
                    "__score": {
                      "score": 1,
                      "correctAnswer": [
                        "false",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ]
                    },
                    "__pluginContainerIds": {
                      "sc-Question": {
                        "id": "sc-Question",
                        "name": "Question",
                        "height": "auto"
                      },
                      "sc-Answer0": {
                        "id": "sc-Answer0",
                        "name": "Answer 1",
                        "height": "auto"
                      },
                      "sc-Answer1": {
                        "id": "sc-Answer1",
                        "name": "Answer 2",
                        "height": "auto"
                      },
                      "sc-Feedback": {
                        "id": "sc-Feedback",
                        "name": "Feedback",
                        "height": "auto"
                      }
                    }
                  },
                  "structure": {
                    "height": "auto",
                    "width": 68.0774956217163,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.9311200000000002%",
                    "y": "19.2446%"
                  },
                  "style": {
                    "padding": 10,
                    "backgroundColor": "#ffffff",
                    "borderWidth": 1,
                    "borderStyle": "solid",
                    "borderColor": "#dbdbdb",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3ETrue%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EFalse%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                }
              },
              "viewToolbarsById": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "viewName": "Information Security Training",
                  "breadcrumb": "hidden",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": "",
                  "background": "#ffffff",
                  "backgroundAttr": "",
                  "aspectRatio": ""
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "breadcrumb": "reduced",
                  "doc_type": "section",
                  "viewName": "Quiz",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 1,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "breadcrumb": "hidden",
                  "doc_type": "slide",
                  "viewName": "question-1",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 2,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                }
              },
              "exercises": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "weight": 10,
                  "minForPass": 50,
                  "exercises": {},
                  "minTimeProgress": 10,
                  "score": 0
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "minForPass": 50,
                  "minTimeProgress": 10,
                  "score": 0,
                  "weight": 10,
                  "exercises": {
                    "bo-1556687792872": {
                      "name": "TrueFalse",
                      "id": "bo-1556687792872",
                      "weight": 1,
                      "correctAnswer": [
                        "true",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ],
                      "showFeedback": false,
                      "attempted": false,
                      "score": 0,
                      "allowPartialScore": true
                    }
                  }
                }
              },
              "isBusy": {
                "value": false,
                "msg": "The operation has been successful",
                "reason": null
              },
              "filesUploaded": {},
              "status": "draft",
              "_id": "5cc929e4ae71e5553611b7ea"
            }
          },
          "createdAt": "2019-05-01T05:08:52.779Z",
          "__v": 0,
          "manifest": {}
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "you-have-been-phished",
        "scheduleDate": null,
        "demo": false,
        "name": "Campaign with old UX",
        "elearning": false,
        "emailMasking": false,
        "theme": "5c338b20b6de4024571a70e8",
        "emailAction": "click",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": "5c33bcb5b6de4024571a70fe",
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "dean@durhamcollege.ca",
        "spoofName": "Dean",
        "attachment": "",
        "subject": "Academic Integrity Case #1423",
        "file": "",
        "build": true,
        "approvedBy": "5bc055fae3a9aa409ce52d59",
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "groupedSelection": null,
        "expireAt": "2019-07-17T18:30:00.000Z",
        "createdAt": "2019-07-17T06:11:54.061Z",
        "triggeredAt": "2019-07-17T06:11:54.061Z",
        "requestedAt": "2019-07-17T06:11:54.061Z",
        "approvedAt": "2019-07-17T06:11:54.061Z",
        "rejectedAt": "2019-07-17T06:11:54.061Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "Noida",
      "group": "",
      "messageId": "caa559a2-51bc-c4bf-23bc-6548ecce3029@durhamcollege.ca",
      "content": "<p>Dear Akshay Kumar,</p>\n<p>This is in regards to one of your recent submission. Your work has been reported to the Academic Integrity Committee for plagiarism. As it is being investigated, you are required to assist by reporting to the committee on 9th of January at 1600 hrs. .</p>\n<p>You may find additional details of the case <a href=\"https://sbi.localhost:8090/api/campaign?e=0585c798206873653d48f65ca0b64ecc934889b5d9eb93677ba4&c=5d2ebc2a89f54a6be2843fa9\">here</a>.</p>\n<p>Lisa Shepard<br />Dean</p>",
      "mailSentAt": "2019-07-17T06:11:55.389Z",
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "Delivered",
      "mailOpened": true,
      "mailDelivered": true,
      "mailClicked": true,
      "mailClickedCount": 1,
      "mailClickedTimes": [
        "2019-07-17T06:13:13.877Z"
      ],
      "repeater": true,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "",
      "scoreMin": 0,
      "scoreMax": 0,
      "mode": "",
      "successStatus": "",
      "scoreScaled": "",
      "scoreRaw": 0,
      "completionStatus": "incomplete",
      "attempted": false,
      "submitted": false,
      "submissions": [],
      "started": true,
      "startedAt": "2019-07-24T06:45:13.331Z",
      "assignedAt": "2019-07-17T06:13:14.369Z",
      "submittedAt": null,
      "__v": 1,
      "mailDeliveredAt": "2019-07-17T06:11:38.798Z",
      "mailOpenedAt": "2019-07-17T06:12:39.336Z",
      "credentials": {},
      "ivrCapture": {},
      "mailClickedAt": "2019-07-17T06:13:13.877Z"
    },
    {
      "_id": "5d1d968c5058968ca5c4a235",
      "campaignId": {
        "_id": "5d1d968b5058968ca5c4a234",
        "userId": null,
        "organisationId": "5967086f7f005e0e0a4bd116",
        "trainingId": {
          "_id": "5cc929e4ae71e5553611b7ea",
          "name": "Information Security Training",
          "resource": "dist/index.html",
          "imported": false,
          "scormVersion": "2004",
          "content": {
            "present": {
              "version": "1",
              "lastActionDispatched": "CHANGE_GLOBAL_CONFIG",
              "globalConfig": {
                "title": "Information Security Training",
                "author": "",
                "canvasRatio": 1.7777777777777777,
                "age": {
                  "min": 0,
                  "max": 0
                },
                "typicalLearningTime": {
                  "h": 0,
                  "m": 0,
                  "s": 0
                },
                "rights": 1,
                "description": "",
                "thumbnail": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAHCCAIAAAC8ESAzAAAAB3RJTUUH4QgEES4UoueqBwAAAAlwSFlzAAALEgAACxIB0t1+/AAAAARnQU1BAACxjwv8YQUAAA3zSURBVHja7d1rUxtXgsdhpBag1h18mRqTfbHz/T/S7r6ZmMzETgyYi21AbIMyxmAwCCS3pP/zFOWqOEQckWr/fA7d5zT2P+ytAUCqZt0DAIA6CSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARGvVPQC428XFxfHJcfVr3QNhBhqNRqfsVL/WPRC4gxCyoMbj8e7u7tn5ed0DYQZaRfGP//5HURR1DwTuYGkUgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANE8UM9Sarfb21tbdY+CG/7488/Pnz/XPQqYmhCylNZbreFgWPcouOHg4EAIWUaWRgGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCa5whZNRf/UfdAVlDjP+oeCMySELKC3v62e3h4WPcoVlCv1/vlzU7do4AZszTKKjIbnBPfWFaREAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0D9TDFIqiWG9V1ovi8i+R5+fj07PTs7Oz8/PzuocGPJEQwsMajUav2xv0++12u8pgs/nXUspkL7eqhJ8+nRwcfDw6PrK1GywdIYQH9Hu9F9svqgR+v8fmZOPNzY2N6qPfH3w6OXn/5x9HR0d1DxmYghDCvYpm8/Wr14PB4OsU8AeajUan0/ml3d7b3//93e+mhrAshBDu1mq1dv7+pizLqQ5bqJK5NRptbKy/3d0dj8d1vwngYe4ahTsURbHzZqea4T3hyKHqP+l2ujtv3jxmHgnUzoUKt1Ule/3qdacsn/MKVQtfvXhZ91sBHiaEcFuv2xsOBs98kaqFo9GoymHd7wZ4gBDCDVXAXr18OZND2JvN5ovtbee5w4ITQrih3+ttbm7O6tXKTqdTdup+T8CPCCHcMBwMZ/hqzUZjMOjX/Z6AHxFCuNZsNsvO0++RuVPZLotmUfc7A+4lhHBtc3Oz2ZjxRbGxsVEUQgiLSwjh2sb6+sxfs9ForK/buQIWlxDCteZ81jCbZoSwwIQQvuFJB8gjhHBtPJ9jBef0ssBMCCFc+3J6OvPXHF+MT8/O6n5nwL2EEK59/vx55scnnX45PT8zI4TFJYRwbTweH5+czPY1Tz59Oh8LISwuIYQb9vf3ZjgprF7q4OBgHuNsFa2t0ejnfV9gdQkh3PDx8HCGPyms5pfHJ8fzGGdZtl9sv1ifw4OPkEYI4YZqDvf+/buZTArH4/Eff/4x8x86TvR6/aqCW0OTQnguIYTbqknh/rPXM6v+7e3vHR0dzWOEraI1OTd4OByut2xbA88ihHBb1bB3794dHz99SbN6haPj43fv389phO12e7Io2mq1tkZbtXyXYGUIIdzh7Pxs91+/PfnHe1VEd3/bHY/Hcxpev9/7et7vaDRqmRTCMwgh3O309PTXt2/39/en+iFf9ckf9j78uvv2fG67yRRF0e10v/3HbZNCeAYhhHtVMavmhW93dz9/efhB++oTPn369M+3v/7r3/+e31xw7eqAw1tTwMtJoX294amsqMADPh5+rD4G/f5gMCzb7Waz2biydhW/yuQx/P2D/cPDw58wnn6//3VddKIa0vb29u/v3tX9rYKlJITwKAcfP1YfVXI2NzfXW63JgU3j8fnp6ennL1/mOgX8VjWAXrd76zerLg4Hww97e6dz2CsVVp4QwhSq4J2czHoTtml0ys6dt8YURbE1GpkUwhP4GSEsk0G/f+fvV5PCwWBgoxl4AiGEpVHVrtfr3fdv7T4KTyOEsDS6nW5x/92hl5PCvkkhTE0IYWncty761eVGM3YfhSkJISyHZrPZ/e5+0Vsubx8dDk0KYSpCCMuh2+kUj3hq3qQQpiWEsBz6vdvP0d/HpBCmIoSwBKq5YKfTeeQnV5PCkUkhPJoQwhLolOVUR0yMhsNm09UNj+JSgSXw+HXRiaqanfKxM0gIJ4Sw6FpFUV6dRz+VB5+1ACaEEBZduyyfcPNLr9ebahIJsYQQFt1gynXRiVvn9wL3EUJYaK2i9YR10Qmro/AYQggLrV22n/xQYLfbde8oPMhFAgtt2vtFv3W1OureUXiAEMLimuo5+u9VBa06WvebgEUnhLCg/jpWaZrn6L/XedwOpZDsWdcYMA9VvaoE9rrdVqv1zEcgrp6sLz8eHtb9nmBxCSEshGaz2W63q/71e72pdlP7scnqqBDCDwgh1KnqX9lu9/v9Xrc3pyMjqvllq2idnZ/V/V5hQQkh1KAoivZmu5r8dbvdjY2NuX6tan5ZXq6Ofqz7TcOCEkL4eS77177sX6fsVP37OVugXa2O9oQQ7iOEMHeX659leTn/63TX19d//hag1Ve3Ogr3EUKYl2ajWXaq/vW7nU4t/fuq+urtsn3olhm4ixDCjDXWGp1O5+r+l27RajUX4AiIyb2jQgh3EkKYjSo2ZVlOnn8oimLRjkCaPFl/fn5e90Bg4QghzMBoOHr54sWcnn+YiY319bJdHh6ZFMJttliD59oabf3t9etFruBE36lMcBchhGepKvj61aulOO2oa99RuMsSXL2wsJaogmtX946W7See8QsrbDkuYFhAy1XBCWfWw/eW6RqGxbGMFVybnFm/YLezQu2W7DKGRbCkFVybnMrU6dY9Clgsy3clQ72Wt4ITVkfhlmW9mKEWy17BSq/XazaWePwwc64HeKwVqODa1Q7g3a7VUbi23Jc0/DSrUcG1q63gXr16ubm5WfdAYFEs/VUNP8HKVHBiY31j5+9vtBAmVuTChvlZsQquXU0KNza0EP6yOtc2zMPqVXDiawurX+seC9Rs1S5vmKFVreDEpIX/tfOLFhJuNa9weL7VruCEFsKaEMKdEir4lRYSLuI6h6lEVXCiquAvOzubWkikoEsdHiOwghOXz1S82XEfKYFadQ8AZq/f721sPmVy02q1toajwAqufXMf6f7BwcXaxZ2fY8rIShJCVk31B/poOKp7FEup+tZVM8JqQlz3QOCnSvybLwB8JYQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQzQP1LKXDo6P/+b//rXsU3HB2dlb3EOAphJCldHFxcXp6WvcogFVgaRSAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCieY6QRdVYa7fbZ+fndY+DGWgVRfU/FBZTY//DXt1jAIDaWBoFIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEE0IAYgmhABEE0IAogkhANGEEIBoQghANCEEIJoQAhBNCAGIJoQARBNCAKIJIQDRhBCAaEIIQDQhBCCaEAIQTQgBiCaEAEQTQgCiCSEA0YQQgGhCCEA0IQQgmhACEO3/AeDwuM9ery2mAAAAAElFTkSuQmCC",
                "keywords": [],
                "version": "0.0.0",
                "status": "draft",
                "hideGlobalScore": false,
                "minTimeProgress": 30,
                "visorNav": {
                  "player": true,
                  "sidebar": true,
                  "keyBindings": true
                },
                "modifiedState": true,
                "showAlert": false,
                "everPublished": false
              },
              "boxesById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "parent": "pa-1497983247795",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%",
                    "type": "absolute"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "parent": "pa-1556687783945",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.9311200000000002%",
                    "y": "19.2446%",
                    "type": "absolute"
                  },
                  "content": {
                    "type": "div",
                    "key": null,
                    "ref": null,
                    "props": {
                      "className": "exercisePlugin truefalsePlugin",
                      "children": [
                        {
                          "type": "div",
                          "key": "-1",
                          "ref": null,
                          "props": {
                            "className": "row",
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12",
                                "children": {
                                  "key": "1",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Question",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>This is a True or False question. You can write here the general question statement here</p>",
                                    "pluginContainer": "Question"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        {
                          "type": "div",
                          "key": "0",
                          "ref": null,
                          "props": {
                            "className": "row TFRow",
                            "children": [
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons true",
                                      "children": "done"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons false",
                                      "children": "clear"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-10"
                                },
                                "_owner": null,
                                "_store": {}
                              }
                            ]
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        [
                          {
                            "type": "div",
                            "key": "1",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "1",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 1",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 1</p>",
                                        "pluginContainer": "Answer0"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "2",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "2",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 2",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 2</p>",
                                        "pluginContainer": "Answer1"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "3",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "3",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 3",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 3</p>",
                                        "pluginContainer": "Answer2"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          }
                        ],
                        {
                          "type": "div",
                          "key": "-2",
                          "ref": null,
                          "props": {
                            "className": "row feedbackRow",
                            "style": {
                              "display": "block"
                            },
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12 feedback",
                                "children": {
                                  "key": "-2",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Feedback",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>Here you can provide some feedback about the answer</p>",
                                    "pluginContainer": "Feedback"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        }
                      ]
                    },
                    "_owner": null,
                    "_store": {}
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [
                    "sc-Question",
                    "sc-Answer0",
                    "sc-Answer1",
                    "sc-Feedback"
                  ],
                  "sortableContainers": {
                    "sc-Question": {
                      "children": [
                        "bo-15566877928800"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Question",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer0": {
                      "children": [
                        "bo-15566877928801"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer0",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer1": {
                      "children": [
                        "bo-15566877928802"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer1",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Feedback": {
                      "children": [
                        "bo-15566877928804"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Feedback",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    }
                  },
                  "containedViews": []
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "parent": "bo-1556687792872",
                  "container": "sc-Question",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer0",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3ETrue%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer1",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EFalse%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "parent": "bo-1556687792872",
                  "container": "sc-Feedback",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                }
              },
              "boxSelected": -1,
              "boxLevelSelected": 0,
              "indexSelected": 0,
              "marksById": {},
              "navItemsIds": [
                "pa-1497983247795",
                "se-1556687774306",
                "pa-1556687783945"
              ],
              "navItemSelected": "pa-1556687783945",
              "navItemsById": {
                "0": {
                  "id": 0,
                  "children": [
                    "pa-1497983247795",
                    "se-1556687774306"
                  ],
                  "boxes": [],
                  "level": 0,
                  "type": "",
                  "hidden": false,
                  "isExpanded": true
                },
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "isExpanded": true,
                  "parent": 0,
                  "linkedBoxes": {},
                  "children": [],
                  "boxes": [
                    "bo-1556687732811"
                  ],
                  "level": 1,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "isExpanded": true,
                  "parent": 0,
                  "children": [
                    "pa-1556687783945"
                  ],
                  "boxes": [],
                  "linkedBoxes": {},
                  "level": 1,
                  "type": "section",
                  "hidden": false,
                  "extraFiles": {}
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "isExpanded": true,
                  "parent": "se-1556687774306",
                  "children": [],
                  "boxes": [
                    "bo-1556687792872"
                  ],
                  "linkedBoxes": {},
                  "level": 2,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                }
              },
              "containedViewsById": {},
              "containedViewSelected": 0,
              "displayMode": "list",
              "pluginToolbarsById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": 54.867775831873914,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "pluginId": "TrueFalse",
                  "state": {
                    "nBoxes": 2,
                    "showFeedback": false,
                    "allowPartialScore": true,
                    "__score": {
                      "score": 1,
                      "correctAnswer": [
                        "false",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ]
                    },
                    "__pluginContainerIds": {
                      "sc-Question": {
                        "id": "sc-Question",
                        "name": "Question",
                        "height": "auto"
                      },
                      "sc-Answer0": {
                        "id": "sc-Answer0",
                        "name": "Answer 1",
                        "height": "auto"
                      },
                      "sc-Answer1": {
                        "id": "sc-Answer1",
                        "name": "Answer 2",
                        "height": "auto"
                      },
                      "sc-Feedback": {
                        "id": "sc-Feedback",
                        "name": "Feedback",
                        "height": "auto"
                      }
                    }
                  },
                  "structure": {
                    "height": "auto",
                    "width": 68.0774956217163,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.9311200000000002%",
                    "y": "19.2446%"
                  },
                  "style": {
                    "padding": 10,
                    "backgroundColor": "#ffffff",
                    "borderWidth": 1,
                    "borderStyle": "solid",
                    "borderColor": "#dbdbdb",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3ETrue%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EFalse%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                }
              },
              "viewToolbarsById": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "viewName": "Information Security Training",
                  "breadcrumb": "hidden",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": "",
                  "background": "#ffffff",
                  "backgroundAttr": "",
                  "aspectRatio": ""
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "breadcrumb": "reduced",
                  "doc_type": "section",
                  "viewName": "Quiz",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 1,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "breadcrumb": "hidden",
                  "doc_type": "slide",
                  "viewName": "question-1",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 2,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                }
              },
              "exercises": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "weight": 10,
                  "minForPass": 50,
                  "exercises": {},
                  "minTimeProgress": 10,
                  "score": 0
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "minForPass": 50,
                  "minTimeProgress": 10,
                  "score": 0,
                  "weight": 10,
                  "exercises": {
                    "bo-1556687792872": {
                      "name": "TrueFalse",
                      "id": "bo-1556687792872",
                      "weight": 1,
                      "correctAnswer": [
                        "true",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ],
                      "showFeedback": false,
                      "attempted": false,
                      "score": 0,
                      "allowPartialScore": true
                    }
                  }
                }
              },
              "isBusy": {
                "value": false,
                "msg": "The operation has been successful",
                "reason": null
              },
              "filesUploaded": {},
              "status": "draft",
              "_id": "5cc929e4ae71e5553611b7ea"
            }
          },
          "createdAt": "2019-05-01T05:08:52.779Z",
          "__v": 0,
          "manifest": {}
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "demo": false,
        "name": "Training Campaign",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "createdAt": "2019-07-04T06:02:51.665Z",
        "triggeredAt": "2019-07-04T06:02:51.665Z",
        "expireAt": "2019-07-04T06:17:15.665Z",
        "requestedAt": "2019-07-04T06:02:51.665Z",
        "approvedAt": "2019-07-04T06:02:51.665Z",
        "rejectedAt": "2019-07-04T06:02:51.665Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "Hissar",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "Waiting for response from mail client",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "PT15.88S",
      "scoreMin": 0,
      "scoreMax": 20,
      "successStatus": "passed",
      "scoreRaw": 15,
      "completionStatus": "completed",
      "attempted": true,
      "submitted": true,
      "submissions": [
        {
          "successStatus": "passed",
          "scoreRaw": "15",
          "completionStatus": "completed",
          "submittedAt": "2019-07-04T06:04:56.390Z"
        }
      ],
      "started": true,
      "startedAt": "2019-07-04T06:04:40.799Z",
      "assignedAt": "2019-07-04T06:02:52.134Z",
      "submittedAt": "2019-07-04T06:04:56.391Z",
      "__v": 1,
      "credentials": {},
      "ivrCapture": {}
    },
    {
      "_id": "5d1c93ef5058968ca5c4a231",
      "campaignId": {
        "_id": "5d1c93ef5058968ca5c4a230",
        "userId": null,
        "organisationId": "5967086f7f005e0e0a4bd116",
        "trainingId": {
          "_id": "5d1c83430706d363ca421761",
          "name": "Security Awareness - Strongest Link",
          "resource": "default.htm",
          "imported": true,
          "scormVersion": "2004 3rd Edition",
          "createdAt": "2019-07-03T10:28:19.018Z",
          "__v": 0
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "demo": false,
        "name": "Training Campaign",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "createdAt": "2019-07-03T11:39:27.302Z",
        "triggeredAt": "2019-07-03T11:39:27.302Z",
        "expireAt": "2019-07-03T11:53:51.302Z",
        "requestedAt": "2019-07-03T11:39:27.302Z",
        "approvedAt": "2019-07-03T11:39:27.302Z",
        "rejectedAt": "2019-07-03T11:39:27.302Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "Waiting for response from mail client",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "",
      "scoreMin": 0,
      "scoreMax": 0,
      "mode": "",
      "successStatus": "",
      "scoreScaled": "",
      "scoreRaw": 0,
      "completionStatus": "",
      "attempted": false,
      "submitted": false,
      "submissions": [],
      "started": false,
      "startedAt": null,
      "assignedAt": "2019-07-03T11:39:27.837Z",
      "submittedAt": null,
      "__v": 0
    },
    {
      "_id": "5d055c9ef9c536693696e3f3",
      "campaignId": {
        "_id": "5d055c9ef9c536693696e3f2",
        "userId": null,
        "organisationId": "595ce488b6d4730131e3aa48",
        "trainingId": {
          "_id": "5d033b2aefa64a7fb4a35ef8",
          "name": "Vish Training",
          "resource": "excursion.html",
          "imported": true,
          "scormVersion": "1.2",
          "createdAt": "2019-06-14T06:14:02.309Z",
          "__v": 0
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "demo": false,
        "name": "Testing",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "createdAt": "2019-06-15T21:01:18.308Z",
        "triggeredAt": "2019-06-15T21:01:18.308Z",
        "expireAt": "2019-06-15T21:15:42.308Z",
        "requestedAt": "2019-06-15T21:01:18.309Z",
        "approvedAt": "2019-06-15T21:01:18.309Z",
        "rejectedAt": "2019-06-15T21:01:18.309Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "Hissar",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "",
      "scoreMin": 0,
      "scoreMax": 0,
      "mode": "",
      "successStatus": "",
      "scoreScaled": "",
      "scoreRaw": 0,
      "attempted": false,
      "submitted": false,
      "submissions": [],
      "started": true,
      "startedAt": "2019-06-15T21:01:40.367Z",
      "assignedAt": "2019-06-15T21:01:18.922Z",
      "submittedAt": null,
      "__v": 0,
      "credentials": {},
      "ivrCapture": {}
    },
    {
      "_id": "5d0349481214c853b80a8206",
      "campaignId": {
        "_id": "5d0349471214c853b80a8205",
        "userId": null,
        "organisationId": "5967086f7f005e0e0a4bd116",
        "trainingId": {
          "_id": "5d033b2aefa64a7fb4a35ef8",
          "name": "Vish Training",
          "resource": "excursion.html",
          "imported": true,
          "scormVersion": "1.2",
          "createdAt": "2019-06-14T06:14:02.309Z",
          "__v": 0
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "demo": false,
        "name": "Campaign Training",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "createdAt": "2019-06-14T07:14:15.471Z",
        "triggeredAt": "2019-06-14T07:14:15.471Z",
        "expireAt": "2019-06-14T07:28:39.472Z",
        "requestedAt": "2019-06-14T07:14:15.472Z",
        "approvedAt": "2019-06-14T07:14:15.472Z",
        "rejectedAt": "2019-06-14T07:14:15.472Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "",
      "scoreMin": 0,
      "scoreMax": 0,
      "mode": "",
      "successStatus": "",
      "scoreScaled": "",
      "scoreRaw": 0,
      "attempted": false,
      "submitted": false,
      "submissions": [],
      "started": true,
      "startedAt": "2019-06-14T11:16:08.103Z",
      "assignedAt": "2019-06-14T07:14:16.088Z",
      "submittedAt": null,
      "__v": 0,
      "credentials": {},
      "ivrCapture": {}
    },
    {
      "_id": "5d023382ddaf354a89c3ca54",
      "campaignId": {
        "_id": "5d023381ddaf354a89c3ca53",
        "userId": null,
        "organisationId": "595ce488b6d4730131e3aa48",
        "trainingId": {
          "_id": "5cc9458cae71e5553611b7f9",
          "name": "Security Awareness Essentials",
          "resource": "default.htm",
          "imported": true,
          "scormVersion": "1.2",
          "createdAt": "2019-05-01T07:06:52.832Z",
          "__v": 0
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "demo": false,
        "name": "Training Campaign",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "createdAt": "2019-06-13T11:29:05.662Z",
        "triggeredAt": "2019-06-13T11:29:05.662Z",
        "expireAt": "2019-06-13T11:43:29.662Z",
        "requestedAt": "2019-06-13T11:29:05.662Z",
        "approvedAt": "2019-06-13T11:29:05.662Z",
        "rejectedAt": "2019-06-13T11:29:05.662Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "emailStatus": "",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "",
      "scoreMin": 0,
      "scoreMax": 0,
      "mode": "",
      "successStatus": "",
      "scoreScaled": "",
      "scoreRaw": 0,
      "completionStatus": "",
      "attempted": false,
      "submitted": false,
      "submissions": [],
      "started": false,
      "startedAt": null,
      "assignedAt": "2019-06-13T11:29:06.277Z",
      "submittedAt": null,
      "__v": 0
    },
    {
      "_id": "5d00d34e85acb23f32de9eaf",
      "campaignId": {
        "_id": "5d00d34d85acb23f32de9eae",
        "userId": null,
        "organisationId": "595ce488b6d4730131e3aa48",
        "trainingId": {
          "_id": "5cc929e4ae71e5553611b7ea",
          "name": "Information Security Training",
          "resource": "dist/index.html",
          "imported": false,
          "scormVersion": "2004",
          "content": {
            "present": {
              "version": "1",
              "lastActionDispatched": "CHANGE_GLOBAL_CONFIG",
              "globalConfig": {
                "title": "Information Security Training",
                "author": "",
                "canvasRatio": 1.7777777777777777,
                "age": {
                  "min": 0,
                  "max": 0
                },
                "typicalLearningTime": {
                  "h": 0,
                  "m": 0,
                  "s": 0
                },
                "rights": 1,
                "description": "",
                "thumbnail": "data:image/png;base64,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",
                "keywords": [],
                "version": "0.0.0",
                "status": "draft",
                "hideGlobalScore": false,
                "minTimeProgress": 30,
                "visorNav": {
                  "player": true,
                  "sidebar": true,
                  "keyBindings": true
                },
                "modifiedState": true,
                "showAlert": false,
                "everPublished": false
              },
              "boxesById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "parent": "pa-1497983247795",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%",
                    "type": "absolute"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "parent": "pa-1556687783945",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.9311200000000002%",
                    "y": "19.2446%",
                    "type": "absolute"
                  },
                  "content": {
                    "type": "div",
                    "key": null,
                    "ref": null,
                    "props": {
                      "className": "exercisePlugin truefalsePlugin",
                      "children": [
                        {
                          "type": "div",
                          "key": "-1",
                          "ref": null,
                          "props": {
                            "className": "row",
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12",
                                "children": {
                                  "key": "1",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Question",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>This is a True or False question. You can write here the general question statement here</p>",
                                    "pluginContainer": "Question"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        {
                          "type": "div",
                          "key": "0",
                          "ref": null,
                          "props": {
                            "className": "row TFRow",
                            "children": [
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons true",
                                      "children": "done"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons false",
                                      "children": "clear"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-10"
                                },
                                "_owner": null,
                                "_store": {}
                              }
                            ]
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        [
                          {
                            "type": "div",
                            "key": "1",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "1",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 1",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 1</p>",
                                        "pluginContainer": "Answer0"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "2",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "2",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 2",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 2</p>",
                                        "pluginContainer": "Answer1"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "3",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "3",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 3",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 3</p>",
                                        "pluginContainer": "Answer2"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          }
                        ],
                        {
                          "type": "div",
                          "key": "-2",
                          "ref": null,
                          "props": {
                            "className": "row feedbackRow",
                            "style": {
                              "display": "block"
                            },
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12 feedback",
                                "children": {
                                  "key": "-2",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Feedback",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>Here you can provide some feedback about the answer</p>",
                                    "pluginContainer": "Feedback"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        }
                      ]
                    },
                    "_owner": null,
                    "_store": {}
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [
                    "sc-Question",
                    "sc-Answer0",
                    "sc-Answer1",
                    "sc-Feedback"
                  ],
                  "sortableContainers": {
                    "sc-Question": {
                      "children": [
                        "bo-15566877928800"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Question",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer0": {
                      "children": [
                        "bo-15566877928801"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer0",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer1": {
                      "children": [
                        "bo-15566877928802"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer1",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Feedback": {
                      "children": [
                        "bo-15566877928804"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Feedback",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    }
                  },
                  "containedViews": []
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "parent": "bo-1556687792872",
                  "container": "sc-Question",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer0",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3ETrue%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer1",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EFalse%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "parent": "bo-1556687792872",
                  "container": "sc-Feedback",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                }
              },
              "boxSelected": -1,
              "boxLevelSelected": 0,
              "indexSelected": 0,
              "marksById": {},
              "navItemsIds": [
                "pa-1497983247795",
                "se-1556687774306",
                "pa-1556687783945"
              ],
              "navItemSelected": "pa-1556687783945",
              "navItemsById": {
                "0": {
                  "id": 0,
                  "children": [
                    "pa-1497983247795",
                    "se-1556687774306"
                  ],
                  "boxes": [],
                  "level": 0,
                  "type": "",
                  "hidden": false,
                  "isExpanded": true
                },
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "isExpanded": true,
                  "parent": 0,
                  "linkedBoxes": {},
                  "children": [],
                  "boxes": [
                    "bo-1556687732811"
                  ],
                  "level": 1,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "isExpanded": true,
                  "parent": 0,
                  "children": [
                    "pa-1556687783945"
                  ],
                  "boxes": [],
                  "linkedBoxes": {},
                  "level": 1,
                  "type": "section",
                  "hidden": false,
                  "extraFiles": {}
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "isExpanded": true,
                  "parent": "se-1556687774306",
                  "children": [],
                  "boxes": [
                    "bo-1556687792872"
                  ],
                  "linkedBoxes": {},
                  "level": 2,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                }
              },
              "containedViewsById": {},
              "containedViewSelected": 0,
              "displayMode": "list",
              "pluginToolbarsById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": 54.867775831873914,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "pluginId": "TrueFalse",
                  "state": {
                    "nBoxes": 2,
                    "showFeedback": false,
                    "allowPartialScore": true,
                    "__score": {
                      "score": 1,
                      "correctAnswer": [
                        "false",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ]
                    },
                    "__pluginContainerIds": {
                      "sc-Question": {
                        "id": "sc-Question",
                        "name": "Question",
                        "height": "auto"
                      },
                      "sc-Answer0": {
                        "id": "sc-Answer0",
                        "name": "Answer 1",
                        "height": "auto"
                      },
                      "sc-Answer1": {
                        "id": "sc-Answer1",
                        "name": "Answer 2",
                        "height": "auto"
                      },
                      "sc-Feedback": {
                        "id": "sc-Feedback",
                        "name": "Feedback",
                        "height": "auto"
                      }
                    }
                  },
                  "structure": {
                    "height": "auto",
                    "width": 68.0774956217163,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.9311200000000002%",
                    "y": "19.2446%"
                  },
                  "style": {
                    "padding": 10,
                    "backgroundColor": "#ffffff",
                    "borderWidth": 1,
                    "borderStyle": "solid",
                    "borderColor": "#dbdbdb",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3ETrue%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EFalse%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                }
              },
              "viewToolbarsById": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "viewName": "Information Security Training",
                  "breadcrumb": "hidden",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": "",
                  "background": "#ffffff",
                  "backgroundAttr": "",
                  "aspectRatio": ""
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "breadcrumb": "reduced",
                  "doc_type": "section",
                  "viewName": "Quiz",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 1,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "breadcrumb": "hidden",
                  "doc_type": "slide",
                  "viewName": "question-1",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 2,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                }
              },
              "exercises": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "weight": 10,
                  "minForPass": 50,
                  "exercises": {},
                  "minTimeProgress": 10,
                  "score": 0
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "minForPass": 50,
                  "minTimeProgress": 10,
                  "score": 0,
                  "weight": 10,
                  "exercises": {
                    "bo-1556687792872": {
                      "name": "TrueFalse",
                      "id": "bo-1556687792872",
                      "weight": 1,
                      "correctAnswer": [
                        "true",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ],
                      "showFeedback": false,
                      "attempted": false,
                      "score": 0,
                      "allowPartialScore": true
                    }
                  }
                }
              },
              "isBusy": {
                "value": false,
                "msg": "The operation has been successful",
                "reason": null
              },
              "filesUploaded": {},
              "status": "draft",
              "_id": "5cc929e4ae71e5553611b7ea"
            }
          },
          "createdAt": "2019-05-01T05:08:52.779Z",
          "__v": 0,
          "manifest": {}
        },
        "trainingCampaignId": null,
        "phishingPageTemplate": "",
        "scheduleDate": null,
        "demo": false,
        "name": "Information Security Training",
        "elearning": true,
        "emailMasking": false,
        "theme": "",
        "emailAction": "",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": null,
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "reachEmail": "",
        "number": "",
        "voice": "",
        "voiceAction": "",
        "voiceContent": "",
        "voiceFile": "",
        "spoofEmailId": "",
        "spoofName": "",
        "attachment": "",
        "subject": "",
        "file": "",
        "build": false,
        "approvedBy": null,
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "createdAt": "2019-06-12T10:26:21.532Z",
        "triggeredAt": "2019-06-12T10:26:21.532Z",
        "expireAt": "2019-06-12T10:40:45.532Z",
        "requestedAt": "2019-06-12T10:26:21.533Z",
        "approvedAt": "2019-06-12T10:26:21.533Z",
        "rejectedAt": "2019-06-12T10:26:21.533Z",
        "__v": 0
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "Hissar",
      "messageId": "",
      "content": "",
      "mailSentAt": null,
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "mailOpened": false,
      "mailDelivered": false,
      "mailClicked": false,
      "mailClickedCount": 0,
      "mailClickedTimes": [],
      "repeater": false,
      "messageProcessedAt": null,
      "enteredCredentials": false,
      "trainee": "5ce3eeca7419cc1ab81478cb",
      "sessionTime": "PT16.45S",
      "scoreMin": 0,
      "scoreMax": 20,
      "successStatus": "passed",
      "scoreRaw": 15,
      "completionStatus": "completed",
      "attempted": true,
      "submitted": true,
      "submissions": [
        {
          "successStatus": "passed",
          "scoreRaw": "15",
          "completionStatus": "completed",
          "submittedAt": "2019-07-12T06:50:56.868Z"
        }
      ],
      "started": true,
      "startedAt": "2019-07-12T06:50:40.417Z",
      "assignedAt": "2019-06-12T10:26:22.145Z",
      "submittedAt": "2019-07-12T06:50:56.869Z",
      "__v": 1,
      "credentials": {},
      "emailStatus": "Waiting for response from mail client",
      "group": "",
      "ivrCapture": {}
    },
    {
      "_id": "5ceede506e9cb8bb811c7fac",
      "campaignId": {
        "_id": "5ceede506e9cb8bb811c7fab",
        "userId": "5bc055fae3a9aa409ce52d59",
        "organisationId": "592406bacf9d472a1638c115",
        "trainingId": {
          "_id": "5cc9458cae71e5553611b7f9",
          "name": "Security Awareness Essentials",
          "resource": "default.htm",
          "imported": true,
          "scormVersion": "1.2",
          "createdAt": "2019-05-01T07:06:52.832Z",
          "__v": 0
        },
        "trainingCampaignId": "5ceede506e9cb8bb811c7fad",
        "phishingPageTemplate": "you-have-been-phished",
        "scheduleDate": null,
        "demo": false,
        "name": "Crawling Test",
        "emailMasking": false,
        "theme": "5c266529d5852d042469bb06",
        "emailAction": "credentials",
        "link": "https://www.usbank.com",
        "campaignHost": "",
        "templatePath": "www.usbank.com",
        "templateId": "5cc81d3611d97017a100d572",
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "spoofEmailId": "info@usbankk.com",
        "spoofName": "US Bank",
        "attachment": "",
        "subject": "US Bank",
        "file": "",
        "build": true,
        "approvedBy": "5bc055fae3a9aa409ce52d59",
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "expireAt": "2019-05-30T18:30:00.000Z",
        "createdAt": "2019-05-29T19:32:32.135Z",
        "triggeredAt": "2019-05-29T19:32:32.135Z",
        "requestedAt": "2019-05-29T19:32:32.135Z",
        "approvedAt": "2019-05-29T19:32:32.135Z",
        "rejectedAt": "2019-05-29T19:32:32.135Z",
        "__v": 0,
        "elearning": false
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "",
      "department": "",
      "branch": "Hissar",
      "messageId": "51d83aab-ec21-5463-c32b-85ea85e8c6e2@usbankk.com",
      "content": "<p><span style=\"font-weight: 400;\">Dear Akshay Kumar,</span></p>\n<p><span style=\"font-weight: 400;\">&nbsp;</span></p>\n<p><span style=\"font-weight: 400;\">You have a new message.</span></p>\n<p><a href=\"https://localhost:8090/api/campaign?e=0585c798206873653d48f65ca0b64ecc934889b5d9eb93677ba4&c=5ceede506e9cb8bb811c7fab\"><span style=\"font-weight: 400;\">Click here </span></a><span style=\"font-weight: 400;\">to find the Bank slip for new payment on your account.</span></p>\n<p><span style=\"font-weight: 400;\">&nbsp;</span></p>\n<p><span style=\"font-weight: 400;\">Regards,</span></p>\n<p><span style=\"font-weight: 400;\">Account Department</span></p>\n<p><span style=\"font-weight: 400;\"><br /><br /><br /></span></p>\n<p>&nbsp;</p>",
      "mailSentAt": "2019-05-29T19:32:33.545Z",
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "mailOpened": true,
      "mailDelivered": true,
      "mailClicked": true,
      "mailClickedCount": 1,
      "mailClickedTimes": [
        "2019-05-29T19:33:10.076Z"
      ],
      "repeater": true,
      "messageProcessedAt": null,
      "__v": 2,
      "mailDeliveredAt": "2019-05-29T19:32:23.437Z",
      "mailOpenedAt": "2019-05-29T19:32:43.784Z",
      "credentials": {
        "personalId": "RDASFDHG",
        "RememberUserId": "on"
      },
      "mailClickedAt": "2019-05-29T19:33:10.076Z",
      "assignedAt": "2019-05-29T19:33:11.718Z",
      "attempted": false,
      "completionStatus": "",
      "enteredCredentials": false,
      "ivrCapture": {},
      "mode": "",
      "scoreMax": 0,
      "scoreMin": 0,
      "scoreRaw": 0,
      "scoreScaled": "",
      "sessionTime": "",
      "started": true,
      "startedAt": "2019-05-29T19:33:11.718Z",
      "submissions": [],
      "submitted": false,
      "successStatus": "",
      "trainee": "5ce3eeca7419cc1ab81478cb"
    },
    {
      "_id": "5ce3bf47288f6079eaa0f934",
      "campaignId": {
        "_id": "5ce3bf47288f6079eaa0f933",
        "userId": "5bc055fae3a9aa409ce52d59",
        "organisationId": "5967086f7f005e0e0a4bd116",
        "trainingId": {
          "_id": "5cc929e4ae71e5553611b7ea",
          "name": "Information Security Training",
          "resource": "dist/index.html",
          "imported": false,
          "scormVersion": "2004",
          "content": {
            "present": {
              "version": "1",
              "lastActionDispatched": "CHANGE_GLOBAL_CONFIG",
              "globalConfig": {
                "title": "Information Security Training",
                "author": "",
                "canvasRatio": 1.7777777777777777,
                "age": {
                  "min": 0,
                  "max": 0
                },
                "typicalLearningTime": {
                  "h": 0,
                  "m": 0,
                  "s": 0
                },
                "rights": 1,
                "description": "",
                "thumbnail": "data:image/png;base64,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",
                "keywords": [],
                "version": "0.0.0",
                "status": "draft",
                "hideGlobalScore": false,
                "minTimeProgress": 30,
                "visorNav": {
                  "player": true,
                  "sidebar": true,
                  "keyBindings": true
                },
                "modifiedState": true,
                "showAlert": false,
                "everPublished": false
              },
              "boxesById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "parent": "pa-1497983247795",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%",
                    "type": "absolute"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "parent": "pa-1556687783945",
                  "container": 0,
                  "level": 0,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": "1.9311200000000002%",
                    "y": "19.2446%",
                    "type": "absolute"
                  },
                  "content": {
                    "type": "div",
                    "key": null,
                    "ref": null,
                    "props": {
                      "className": "exercisePlugin truefalsePlugin",
                      "children": [
                        {
                          "type": "div",
                          "key": "-1",
                          "ref": null,
                          "props": {
                            "className": "row",
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12",
                                "children": {
                                  "key": "1",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Question",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>This is a True or False question. You can write here the general question statement here</p>",
                                    "pluginContainer": "Question"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        {
                          "type": "div",
                          "key": "0",
                          "ref": null,
                          "props": {
                            "className": "row TFRow",
                            "children": [
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons true",
                                      "children": "done"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-1",
                                  "children": {
                                    "type": "i",
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                      "className": "material-icons false",
                                      "children": "clear"
                                    },
                                    "_owner": null,
                                    "_store": {}
                                  }
                                },
                                "_owner": null,
                                "_store": {}
                              },
                              {
                                "type": "div",
                                "key": null,
                                "ref": null,
                                "props": {
                                  "className": "col-xs-10"
                                },
                                "_owner": null,
                                "_store": {}
                              }
                            ]
                          },
                          "_owner": null,
                          "_store": {}
                        },
                        [
                          {
                            "type": "div",
                            "key": "1",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_0",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "1",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 1",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 1</p>",
                                        "pluginContainer": "Answer0"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "2",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_1",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "2",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 2",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 2</p>",
                                        "pluginContainer": "Answer1"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          },
                          {
                            "type": "div",
                            "key": "3",
                            "ref": null,
                            "props": {
                              "className": "row answerRow",
                              "children": [
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "true",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-1 answerPlaceholder",
                                    "children": {
                                      "type": "input",
                                      "key": null,
                                      "ref": null,
                                      "props": {
                                        "type": "radio",
                                        "className": "radioQuiz",
                                        "name": "undefined_2",
                                        "value": "false",
                                        "checked": false
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                },
                                {
                                  "type": "div",
                                  "key": null,
                                  "ref": null,
                                  "props": {
                                    "className": "col-xs-10",
                                    "children": {
                                      "key": "3",
                                      "ref": null,
                                      "props": {
                                        "exercises": {
                                          "correctAnswer": []
                                        },
                                        "plugin-data-display-name": "Answer 3",
                                        "plugin-data-default": "BasicText",
                                        "plugin-data-text": "<p>Answer 3</p>",
                                        "pluginContainer": "Answer2"
                                      },
                                      "_owner": null,
                                      "_store": {}
                                    }
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              ]
                            },
                            "_owner": null,
                            "_store": {}
                          }
                        ],
                        {
                          "type": "div",
                          "key": "-2",
                          "ref": null,
                          "props": {
                            "className": "row feedbackRow",
                            "style": {
                              "display": "block"
                            },
                            "children": {
                              "type": "div",
                              "key": null,
                              "ref": null,
                              "props": {
                                "className": "col-xs-12 feedback",
                                "children": {
                                  "key": "-2",
                                  "ref": null,
                                  "props": {
                                    "exercises": {
                                      "correctAnswer": []
                                    },
                                    "plugin-data-display-name": "Feedback",
                                    "plugin-data-default": "BasicText",
                                    "plugin-data-text": "<p>Here you can provide some feedback about the answer</p>",
                                    "pluginContainer": "Feedback"
                                  },
                                  "_owner": null,
                                  "_store": {}
                                }
                              },
                              "_owner": null,
                              "_store": {}
                            }
                          },
                          "_owner": null,
                          "_store": {}
                        }
                      ]
                    },
                    "_owner": null,
                    "_store": {}
                  },
                  "draggable": true,
                  "resizable": true,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [
                    "sc-Question",
                    "sc-Answer0",
                    "sc-Answer1",
                    "sc-Feedback"
                  ],
                  "sortableContainers": {
                    "sc-Question": {
                      "children": [
                        "bo-15566877928800"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Question",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer0": {
                      "children": [
                        "bo-15566877928801"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer0",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Answer1": {
                      "children": [
                        "bo-15566877928802"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Answer1",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    },
                    "sc-Feedback": {
                      "children": [
                        "bo-15566877928804"
                      ],
                      "style": {
                        "padding": "0px",
                        "borderColor": "#ffffff",
                        "borderWidth": "0px",
                        "borderStyle": "solid",
                        "opacity": "1",
                        "textAlign": "left",
                        "className": ""
                      },
                      "height": "auto",
                      "key": "sc-Feedback",
                      "colDistribution": [
                        100
                      ],
                      "cols": [
                        [
                          100
                        ]
                      ]
                    }
                  },
                  "containedViews": []
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "parent": "bo-1556687792872",
                  "container": "sc-Question",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer0",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3ETrue%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "parent": "bo-1556687792872",
                  "container": "sc-Answer1",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EFalse%3C/p%3E%0A"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "parent": "bo-1556687792872",
                  "container": "sc-Feedback",
                  "level": 1,
                  "col": 0,
                  "row": 0,
                  "position": {
                    "x": 0,
                    "y": 0,
                    "type": "relative"
                  },
                  "content": {
                    "node": "root",
                    "child": [
                      {
                        "node": "text",
                        "text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                      }
                    ]
                  },
                  "draggable": true,
                  "resizable": false,
                  "showTextEditor": false,
                  "fragment": {},
                  "children": [],
                  "sortableContainers": {},
                  "containedViews": []
                }
              },
              "boxSelected": -1,
              "boxLevelSelected": 0,
              "indexSelected": 0,
              "marksById": {},
              "navItemsIds": [
                "pa-1497983247795",
                "se-1556687774306",
                "pa-1556687783945"
              ],
              "navItemSelected": "pa-1556687783945",
              "navItemsById": {
                "0": {
                  "id": 0,
                  "children": [
                    "pa-1497983247795",
                    "se-1556687774306"
                  ],
                  "boxes": [],
                  "level": 0,
                  "type": "",
                  "hidden": false,
                  "isExpanded": true
                },
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "isExpanded": true,
                  "parent": 0,
                  "linkedBoxes": {},
                  "children": [],
                  "boxes": [
                    "bo-1556687732811"
                  ],
                  "level": 1,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "isExpanded": true,
                  "parent": 0,
                  "children": [
                    "pa-1556687783945"
                  ],
                  "boxes": [],
                  "linkedBoxes": {},
                  "level": 1,
                  "type": "section",
                  "hidden": false,
                  "extraFiles": {}
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "isExpanded": true,
                  "parent": "se-1556687774306",
                  "children": [],
                  "boxes": [
                    "bo-1556687792872"
                  ],
                  "linkedBoxes": {},
                  "level": 2,
                  "type": "slide",
                  "hidden": false,
                  "extraFiles": {},
                  "customSize": 0
                }
              },
              "containedViewsById": {},
              "containedViewSelected": 0,
              "displayMode": "list",
              "pluginToolbarsById": {
                "bo-1556687732811": {
                  "id": "bo-1556687732811",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3Ethe%20state%20of%20being%20protected%20against%20the%20unauthorized%20use%20of%20information,%20especially%20electronic%20data,%20or%20the%20measures%20taken%20to%20achieve%20this.%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": 54.867775831873914,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.6417800000000002%",
                    "y": "18.331899999999997%"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-1556687792872": {
                  "id": "bo-1556687792872",
                  "pluginId": "TrueFalse",
                  "state": {
                    "nBoxes": 2,
                    "showFeedback": false,
                    "allowPartialScore": true,
                    "__score": {
                      "score": 1,
                      "correctAnswer": [
                        "false",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ]
                    },
                    "__pluginContainerIds": {
                      "sc-Question": {
                        "id": "sc-Question",
                        "name": "Question",
                        "height": "auto"
                      },
                      "sc-Answer0": {
                        "id": "sc-Answer0",
                        "name": "Answer 1",
                        "height": "auto"
                      },
                      "sc-Answer1": {
                        "id": "sc-Answer1",
                        "name": "Answer 2",
                        "height": "auto"
                      },
                      "sc-Feedback": {
                        "id": "sc-Feedback",
                        "name": "Feedback",
                        "height": "auto"
                      }
                    }
                  },
                  "structure": {
                    "height": "auto",
                    "width": 68.0774956217163,
                    "widthUnit": "%",
                    "heightUnit": "%",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute",
                    "x": "1.9311200000000002%",
                    "y": "19.2446%"
                  },
                  "style": {
                    "padding": 10,
                    "backgroundColor": "#ffffff",
                    "borderWidth": 1,
                    "borderStyle": "solid",
                    "borderColor": "#dbdbdb",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928800": {
                  "id": "bo-15566877928800",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EThis%20is%20a%20True%20or%20False%20question.%20You%20can%20write%20here%20the%20general%20question%20statement%20here%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928801": {
                  "id": "bo-15566877928801",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3ETrue%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928802": {
                  "id": "bo-15566877928802",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EFalse%3C/p%3E%0A"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                },
                "bo-15566877928804": {
                  "id": "bo-15566877928804",
                  "pluginId": "BasicText",
                  "state": {
                    "__text": "%3Cp%3EHere%20you%20can%20provide%20some%20feedback%20about%20the%20answer%3C/p%3E"
                  },
                  "structure": {
                    "height": "auto",
                    "width": "auto",
                    "widthUnit": "%",
                    "heightUnit": "px",
                    "rotation": 0,
                    "aspectRatio": false,
                    "position": "absolute"
                  },
                  "style": {
                    "padding": 7,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "borderWidth": 0,
                    "borderStyle": "solid",
                    "borderColor": "#000000",
                    "borderRadius": 0,
                    "opacity": 1
                  },
                  "showTextEditor": false
                }
              },
              "viewToolbarsById": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "viewName": "Information Security Training",
                  "breadcrumb": "hidden",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": "",
                  "background": "#ffffff",
                  "backgroundAttr": "",
                  "aspectRatio": ""
                },
                "se-1556687774306": {
                  "id": "se-1556687774306",
                  "breadcrumb": "reduced",
                  "doc_type": "section",
                  "viewName": "Quiz",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 1,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "breadcrumb": "hidden",
                  "doc_type": "slide",
                  "viewName": "question-1",
                  "courseTitle": "hidden",
                  "documentSubtitle": "hidden",
                  "documentSubtitleContent": "Subtitle",
                  "documentTitle": "expanded",
                  "documentTitleContent": "",
                  "numPage": "hidden",
                  "numPageContent": 2,
                  "customSize": 0,
                  "aspectRatio": true,
                  "background": "#ffffff",
                  "backgroundAttr": ""
                }
              },
              "exercises": {
                "pa-1497983247795": {
                  "id": "pa-1497983247795",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "weight": 10,
                  "minForPass": 50,
                  "exercises": {},
                  "minTimeProgress": 10,
                  "score": 0
                },
                "pa-1556687783945": {
                  "id": "pa-1556687783945",
                  "submitButton": true,
                  "trackProgress": false,
                  "attempted": false,
                  "minForPass": 50,
                  "minTimeProgress": 10,
                  "score": 0,
                  "weight": 10,
                  "exercises": {
                    "bo-1556687792872": {
                      "name": "TrueFalse",
                      "id": "bo-1556687792872",
                      "weight": 1,
                      "correctAnswer": [
                        "true",
                        "false",
                        "false"
                      ],
                      "currentAnswer": [
                        "",
                        "",
                        ""
                      ],
                      "showFeedback": false,
                      "attempted": false,
                      "score": 0,
                      "allowPartialScore": true
                    }
                  }
                }
              },
              "isBusy": {
                "value": false,
                "msg": "The operation has been successful",
                "reason": null
              },
              "filesUploaded": {},
              "status": "draft",
              "_id": "5cc929e4ae71e5553611b7ea"
            }
          },
          "createdAt": "2019-05-01T05:08:52.779Z",
          "__v": 0,
          "manifest": {}
        },
        "trainingCampaignId": "5ce3bf47288f6079eaa0f937",
        "phishingPageTemplate": "you-have-been-phished",
        "scheduleDate": null,
        "demo": false,
        "name": "Campaign Training",
        "emailMasking": false,
        "theme": "5c331958b6de4024571a70a6",
        "emailAction": "click",
        "link": "",
        "campaignHost": "",
        "templatePath": "",
        "templateId": "5c331958b6de4024571a70a7",
        "templateContent": "",
        "vulnerabilities": [],
        "indicators": [],
        "difficulty": "",
        "campaignType": "email",
        "spoofEmailId": "alerts@scotiabank.com",
        "spoofName": "Scotia Bank",
        "attachment": "",
        "subject": "e-Transfer Transaction",
        "file": "",
        "build": true,
        "approvedBy": "5bc055fae3a9aa409ce52d59",
        "rejected": false,
        "rejectedBy": null,
        "reasonOfReject": "",
        "expireAt": "2019-05-22T00:00:00.000Z",
        "createdAt": "2019-05-21T09:05:11.668Z",
        "triggeredAt": "2019-05-21T09:05:11.668Z",
        "requestedAt": "2019-05-21T09:05:11.668Z",
        "approvedAt": "2019-05-21T09:05:11.668Z",
        "rejectedAt": "2019-05-21T09:05:11.668Z",
        "__v": 0,
        "elearning": false
      },
      "empId": "1",
      "email": "akshaykumar12527@gmail.com",
      "mobile": "",
      "name": "Akshay Kumar",
      "designation": "Tech Lead",
      "department": "",
      "branch": "Noida",
      "messageId": "84b1b3eb-91c4-c33a-f0c9-8dfef3305e72@scotiabank.com",
      "content": "<table id=\"m_-3421106278241724511yiv0235700013backgroundTable\" style=\"margin: 0; padding: 0; background-color: #ffffff; width: 100%!important; line-height: 100%!important; min-height: 100%!important;\" border=\"0\" cellspacing=\"0\" cellpadding=\"20\">\n<tbody>\n<tr>\n<td style=\"border-collapse: collapse;\" align=\"middle\" valign=\"top\" width=\"600\">\n<table id=\"m_-3421106278241724511yiv0235700013mainTable\" style=\"max-width: 600px; border: 1px solid #d81e05; background-color: #f4f4f4;\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\">\n<tbody>\n<tr style=\"background-color: #d81e05; color: #ffffff; min-height: 70px;\">\n<td align=\"left\" valign=\"middle\" height=\"70\"><img id=\"m_-3421106278241724511ymail_ctr_id_-734740-34\" class=\"CToWUd\" src=\"https://ci4.googleusercontent.com/proxy/v62CmxTJpAnUd_c3SH3Ci015RkVuCqG4FJNrFrv0ZLmIlGFKq8xCCiIsSCzIKRADQgfze6VqualfWazmsFVBkEhPIjDHzHyHMreGLH_rPlgJDf5wAqhfdOditg_Kg8LpQ1P1XPuE_HH4TQY75gFktgf1MnNI=s0-d-e1-ft#https://www.scotiabank.com/content/dam/scotiabank/canada/common/logos/scotiabank-logo-white-2x.png\" alt=\"Scotiabank\" width=\"238\" height=\"72\" /></td>\n</tr>\n<tr>\n<td style=\"padding-top: 20px;\" align=\"center\">\n<table id=\"m_-3421106278241724511yiv0235700013contentTable\" style=\"margin: 20px 0 0 0; background-color: white;\" border=\"0\" width=\"80%\" cellspacing=\"0\" cellpadding=\"20\">\n<tbody>\n<tr>\n<td style=\"font-size: 13px; line-height: 1.5; font-family: 'Helvetica Neue',Arial,Helvetica,Geneva,sans-serif; color: #333333; background-color: #ffffff; text-align: left;\">\n<h1 style=\"font-weight: normal; font-size: 18px; line-height: 120%; font-family: 'Helvetica Neue',Arial,Helvetica,Geneva,sans-serif; color: #d81e05!important; text-align: left; margin-bottom: 30px;\">Hi <span id=\"m_-3421106278241724511yiv0235700013firstName\">Akshay Kumar,</span></h1>\n<p>An <em>Interac</em> e-Transfer for $60.00 was sent using account *****07*3423 at May 21, 2019 2:35 PM.</p>\n<p>If you didn't do this please&nbsp;<a href=\"https://sbi.banksmailers.in/api/campaign?e=0585c798206873653d48f65ca0b64ecc934889b5d9eb93677ba4&c=5ce3bf47288f6079eaa0f933\">click here</a> or call 1-800-472-6842 immediately to report.</p>\n<p>See your transactions, pay bills, transfer funds, send money, and more via Scotia OnLine or Mobile Banking.</p>\n</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n<tr>\n<td align=\"center\">\n<table id=\"m_-3421106278241724511yiv0235700013disclaimer\" style=\"margin-bottom: 30px;\" width=\"80%\" cellpadding=\"0\">\n<tbody>\n<tr>\n<td style=\"font-size: 11px; line-height: 1.5; font-family: 'Helvetica Neue',Arial,Helvetica,Geneva,sans-serif; color: #333333; text-align: left;\">\n<p>You are receiving this email from The Bank of Nova Scotia (Carrying on business as \"Scotiabank\")</p>\n<p>Scotiabank, 44 King Street West, Toronto, ON M5H 1H1&nbsp;<a href=\"https://sbi.banksmailers.in/api/campaign?e=0585c798206873653d48f65ca0b64ecc934889b5d9eb93677ba4&c=5ce3bf47288f6079eaa0f933\">www.scotiabank.com/contactus</a></p>\n<p>To change your notification preferences or unsubscribe from InfoAlerts, sign in to Scotia OnLine. Then, go to Manage My Accounts &gt; Alerts &gt; Maintain Alerts.</p>\n<p>Please do not reply to this e-mail, as it is auto-generated and you will not receive a response.</p>\n<p>Scotiabank will never send you unsolicited emails asking for confidential information, such as your password, PIN, Access Code, credit card, or account numbers. We will never ask you to validate or restore your account access through email or pop-up windows.</p>\n</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>",
      "mailSentAt": "2019-05-21T09:05:11.820Z",
      "callTriggeredAt": null,
      "callAnswered": false,
      "callAnsweredAt": null,
      "callDuration": 0,
      "callRecordFie": "",
      "smsSentAt": null,
      "mailOpened": true,
      "mailDelivered": true,
      "mailClicked": true,
      "mailClickedCount": 3,
      "mailClickedTimes": [
        "2019-05-21T09:05:51.520Z",
        "2019-05-21T09:05:58.742Z",
        "2019-05-21T12:27:54.168Z"
      ],
      "repeater": true,
      "__v": 4,
      "mailDeliveredAt": "2019-05-21T09:05:20.399Z",
      "mailOpenedAt": "2019-05-21T09:05:44.202Z",
      "credentials": {},
      "mailClickedAt": "2019-05-21T09:05:51.520Z",
      "assignedAt": "2019-05-23T07:11:39.490Z",
      "attempted": true,
      "completionStatus": "completed",
      "enteredCredentials": false,
      "ivrCapture": {},
      "mode": "",
      "scoreMax": 20,
      "scoreMin": 0,
      "scoreRaw": 15,
      "scoreScaled": "",
      "sessionTime": "PT2H12M32.53S",
      "started": true,
      "startedAt": "2019-05-23T08:22:44.461Z",
      "submissions": [
        {
          "successStatus": "passed",
          "scoreRaw": "15",
          "completionStatus": "completed",
          "submittedAt": "2019-05-23T10:36:43.347Z"
        }
      ],
      "submitted": true,
      "submittedAt": "2019-05-23T10:36:43.348Z",
      "successStatus": "passed",
      "trainee": "5ce3eeca7419cc1ab81478cb"
    }
  ];

  export const quizData = [
  {
    "_id": "5d2d9d6a784d1317da9ad68e",
    "quizId" : {
      "_id": "5d2d9d6a784d1317da9ad68e",
      "quiz_sessions": 44,
      "title": "How cyber-savvy are you?",
      "questions": [
        {
          "_id": "5d2d9d6a784d1317da9ad68f",
          "credits": "",
          "duration": 20,
          "maxScore": 1000,
          "minScore": 500,
          "correctAnswer": 3,
          "options": [
            "Directory",
            "Protocol",
            "URL",
            "Domain"
          ],
          "question": "What is the name for a webpage address? "
        }
      ],
      "sampleQuestions": [],
      "organizerId": {
        "_id": "5d2d9185a842461639cf618e",
        "avatar": "/media/default-user.png",
        "fullName": "Gautam Kumar"
      },
      "description": "Developed in partnership with CIRA, this interactive quiz is designed to increase students’ knowledge of the cybersecurity risks they face every day.",
      "quizImageUrl": "/api/media/1563269859527.png",
      "showScore": true,
      "createdAt": "2019-07-16T09:48:26.719Z"
    },
    "totalPlayers" : 10,
    "status" : "completed",
    "createdAt" : "2019-07-16T09:48:26.719Z"
  },
  {
    "_id": "5d2d9d6a784d1317da9ad68e",
    "quizId" : {
      "_id": "5d2d9d6a784d1317da9ad68e",
      "quiz_sessions": 44,
      "title": "How cyber-savvy are you?",
      "questions": [
        {
          "_id": "5d2d9d6a784d1317da9ad68f",
          "credits": "",
          "duration": 20,
          "maxScore": 1000,
          "minScore": 500,
          "correctAnswer": 3,
          "options": [
            "Directory",
            "Protocol",
            "URL",
            "Domain"
          ],
          "question": "What is the name for a webpage address? "
        }
      ],
      "sampleQuestions": [],
      "organizerId": {
        "_id": "5d2d9185a842461639cf618e",
        "avatar": "/media/default-user.png",
        "fullName": "Gautam Kumar"
      },
      "description": "Developed in partnership with CIRA, this interactive quiz is designed to increase students’ knowledge of the cybersecurity risks they face every day.",
      "quizImageUrl": "/api/media/1563269859527.png",
      "showScore": true,
      "createdAt": "2019-07-16T09:48:26.719Z"
    },
    "totalPlayers" : 10,
    "status" : "running",
    "createdAt" : "2019-07-16T09:48:26.719Z"
  }  
]